import React from "react";

const LabelDisplayField = ({
  field, // { name, value, onChange, onBlur }
  label,
  size = 12,
  inputGroupClassName = "form-group",
  ...props
}) => {
  return (
    <div style={{ width: '100%' }} className={`${inputGroupClassName} col-lg-${size}`}>
      {label && <label className="custom-label-style">{label}</label>}
      <div 
        style={{ 
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        {field.value || ''}
      </div>
    </div>
  );
};

export default LabelDisplayField;